const ES_US_LOCALE = 'es-US'

module.exports = {
  ES_US_LOCALE,
  supportedLocales: ['en-AU', 'en-NZ', 'en-US', 'en-GB', 'en-CA', 'fr-CA', ES_US_LOCALE, 'catchAll'],
}
